// ======================================================================
// File Name       : index
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// ## ROOT_URL SETTING ##
// ####################################################################
// ## LOCAL ENVIRONEMT ##
//export const ROOT_URL = 'https://ss-txdev-cms.l-cloud-dev.jp';
//export const ROOT_URL = 'https://ss-txmnt-cms.l-cloud-dev.jp';
// ## ST ENVIRONEMT ##
export const ROOT_URL = `${window.location.protocol}//${window.location.hostname}`;


// ########## TXDEV ENVIRONEMT ##########
// export const COMMON_DOMAIN = 'https://ss-txdev-api.l-cloud-dev.jp';
// export const DRILL_SERVER_ROOT_URL = 'https://ss-txdev-drl.l-cloud-dev.jp';
// export const VIDEO_SERVER_URL = 'https://stg-avis.video-cloud.jp';
// export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
// export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
// export const AWS_BUCKET = 'ss-txdev-s3-ntttx-video-source';
// export const EXTERNAL_REQUEST_PASSCD = 'Os8PHxyUpwOw8dH5N+2Ioz1PdUN9YTCB';
// export const REDIRECT_DOMAIN = 'https://ss-signup.l-cloud.jp';

// ########## TXMNT ENVIRONEMT ##########
// export const COMMON_DOMAIN = 'https://ss-txmnt-api.l-cloud-dev.jp';
// export const DRILL_SERVER_ROOT_URL = 'https://ss-txmnt-drl.l-cloud-dev.jp';
// export const VIDEO_SERVER_URL = 'https://stg-avis.video-cloud.jp';
// export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
// export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
// export const AWS_BUCKET = 'ss-txmnt-s3-ntttx-video-source';
// export const EXTERNAL_REQUEST_PASSCD = 'Os8PHxyUpwOw8dH5N+2Ioz1PdUN9YTCB';
// export const REDIRECT_DOMAIN = 'https://ss-signup.l-cloud.jp';

// ########## EAST DEV ENVIRONEMT ##########
// export const COMMON_DOMAIN = 'https://dev-ss-api.l-cloud-dev.jp';
// export const DRILL_SERVER_ROOT_URL = 'https://dev-ss-drl.l-cloud-dev.jp';
// export const VIDEO_SERVER_URL = 'https://stg-avis.video-cloud.jp';
// export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
// export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
// export const AWS_BUCKET = 'ss-dev-s3-ntttx-video-source';
// export const EXTERNAL_REQUEST_PASSCD = 'CnhwL6CO+Tlrk/6zXzSKHluQOA/Pq+qa';
// export const REDIRECT_DOMAIN = 'https://l-cloud-dev.jp';

// ########## EAST MNT ENVIRONEMT ##########
// export const COMMON_DOMAIN = 'https://mnt-ss-api.l-cloud-dev.jp';
// export const DRILL_SERVER_ROOT_URL = 'https://mnt-ss-drl.l-cloud-dev.jp';
// export const VIDEO_SERVER_URL = 'https://stg-avis.video-cloud.jp';
// export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
// export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
// export const AWS_BUCKET = 'ss-mnt-s3-ntttx-video-source';
// export const EXTERNAL_REQUEST_PASSCD = 'AIJ7nYHoWKa30hydpsaiT9WMxhsy/p29';
// export const REDIRECT_DOMAIN = 'https://mnt.l-cloud-dev.jp';

// ########## EAST TBD ENVIRONEMT ##########
// export const COMMON_DOMAIN = 'https://tbd-ss-api.l-cloud-dev.jp';
// export const DRILL_SERVER_ROOT_URL = 'https://tbd-ss-drl.l-cloud-dev.jp';
// export const VIDEO_SERVER_URL = 'https://stg-avis.video-cloud.jp';
// export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
// export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
// export const AWS_BUCKET = 'ss-tbd-s3-ntttx-video-source';
// export const EXTERNAL_REQUEST_PASSCD = 'BSeNpmBw8q1oceaCPD3JJTEB6klZPVN6';
// export const REDIRECT_DOMAIN = 'https://tbd.l-cloud-dev.jp';

// ########## EAST STG ENVIRONEMT ##########
// export const COMMON_DOMAIN = 'https://stg-ss-api.l-cloud-stg.jp';
// export const DRILL_SERVER_ROOT_URL = 'https://stg-ss-drl.l-cloud-stg.jp';
// export const VIDEO_SERVER_URL = 'https://stg-avis.video-cloud.jp';
// export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
// export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
// export const AWS_BUCKET = 'ss-stg-s3-ntttx-video-source';
// export const EXTERNAL_REQUEST_PASSCD = 'ENt3LUHIjM2j7pDq9+voRpkSUqeG8wLU';
// export const REDIRECT_DOMAIN = 'https://l-cloud-stg.jp';

// ########## EAST BIZ ENVIRONEMT ##########
export const COMMON_DOMAIN = 'https://ss-api.l-cloud.jp';
export const DRILL_SERVER_ROOT_URL = 'https://ss-drl.l-cloud.jp';
export const VIDEO_SERVER_URL = 'https://avis.video-cloud.jp';
export const IS_SHOW_MENU_DEVELOP_FEATURE_51 = true;
export const IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 = false;
export const AWS_BUCKET = 'ss-biz-s3-ntttx-video-source';
export const EXTERNAL_REQUEST_PASSCD = 'hWII37JxvqvZZoisMxQATbyT3n2ucN6D';
export const REDIRECT_DOMAIN = 'https://l-cloud.jp';

// ####################################################################

// Config show log
export const DEV_MODE = true;
//export const DEV_MODE = process.env.NODE_ENV !== 'production';

// Config to replace video server URL by newfront server URL
export const IS_REPLACE_VIDEO_URL = true;

// Config vcube
export const MEETING_VCUBE_QA_URL = 'https://jp.vcube.com/support/meeting5/faq/';
export const MEETING_VCUBE_CONNECTION_CHECK_URL = 'https://mtg-support.vcube.com/hc/ja/articles/900004851763'; /* #7145 */

// リリース時、変更不可な設定
export const FRONTGW_SERVER_URL = `${ROOT_URL}/frontgw`;
export const DRILL_SERVER_URL = `${ROOT_URL}/drill`;
export const DRILL_SKIN_CLIENT_URL = `${DRILL_SERVER_ROOT_URL}/DrillClient/:institutionId/:skinSetSecernId/drill/index.html`;
export const DRILL_QUESTION_SKIN_CLIENT_URL = `${DRILL_SERVER_ROOT_URL}/QuestionPreview/question/index.html#/preview`;

export const AUTH_REDIRECT_URL = `${ROOT_URL}/auth_error.html`;
export const RETURN_PAGE_END = AUTH_REDIRECT_URL;
export const RETURN_PAGE = AUTH_REDIRECT_URL;
export const QUESTION_CONVERT_ERROR_URL = `${ROOT_URL}/question_convert_error.html`;
export const VIDEO_SERVER_URL_REPLACE = `${ROOT_URL}/video`;

export const X_SSAPI_VERSION = '2.0.0';
export const DISABLE = 'DISABLE';
export const CAN_ACCESS = 'CAN_ACCESS';
export const LO_SUPER_USER = 0;
export const SUPER_USER = 1;
export const READ = 1;
export const WRITE = 2;
export const LIST_INFO = 0;

export const UNPUBLIC = 0;
export const PUBLIC = 1;
export const SUPER_USER_SECERN_ID = 'superuser';

export const STATUS_CD = {
  LOGIN_ERROR: 7,
};

export const USAGE_SETTING = {
  UN_USE: 0,
  USE: 1,
};

/**
 * Structure level
 * This use for when fetch structure data
 */
export const STRUCTURE_LEVEL = {
  DIRECT: 0,
  ALL: 1,
};

/**
 * Structure type
 */
export const STRUCTURE_TYPE = {
  COURSE: 0,
  BOX: 1,
  ITEM: 2,
};

export const RETURN_MAX_NUM = 20;
export const RETURN_MAX_NUM_TOP = 5;
export const RETURN_MAX_NUM_1000 = 1000;
export const GUIDELINE_PASSWORD_STRENGTH = { password_strength: 'PasswordStrength.html' };
// MODE
export const MODE = {
  EDIT_MODE: 1,
  NEW_MODE: 0,
  DELETE_MODE: 2,
};

// password strength type
export const PASS_STRENGTH_TYPE = {
  STRONG: 0,
  MEDIUM: 1,
  WEAK: 2,
};

// min pass length
export const MIN_PASS_LENGTH = {
  NOT_WEAK: 8,
  WEAK: 4,
};

export const SELECT_TARGET_DATA = {
  DATA: 0,
  CSV: 1,
};
export const MODAL_SIZE = { sm: 'small', lg: 'large' };
export const MESSAGE_TIME_OUT = 2000;
export const VALIDATE_TYPE = {
  URL: 0,
  NUMERIC: 1,
  ID: 2,
  ID_INCLUDING_HYPHEN: 3,
  PASSWORD: 4,
  PASSWORD_CONFIRM: 5,
  INVOICE_NUMBER: 6,
  EMAIL: 7,
  REAL_NUMBER: 8,
  COURSE_BOX_ID: 9,
  DRILL_QUESTION_SETTING: 10,
  LABEL: 11,
  IMG_FILE: 12,
  MAX_NUMBER: 13,
  NUMBERIC_OVERLAP: 14,
  PATTERN: 15,
  LOGIN_ID: 16,
  ID_CHECKOVERLAP: 17,
  REQUIRED: 18,
  DATE_TIME: 19,
  DOCUMENT_SIZE: 20,
  VIDEO_SIZE: 21,
  QUESTION_ANSWER: 22,
  ITEM_COURSE_END: 23,
  DATE_TIME_MIN_MAX: 24,
  REPORT_TIME_MIN_MAX: 25,
  DATE_TIME_WITH_LIMIT: 26,
  ITEM_BOX_END: 27,
  QUESTION_SELECTIVE_SINGLE_ANSWER: 28,
  REQUIRED_SELECTBOX_NOTICE: 29,
  THUMBNAIL_SIZE_AND_TYPE: 30,
  THUMBNAIL_SIZE: 31,
  REQUIRED_ARRAY: 32,
  REQUIRED_FILE: 33,
  NOT_ACCEPT_FILE: 34,
  ACCEPT_FILE: 35,
  SAME_MINUTE: 36,
  SAME_DAY: 37,
  MAX_ARRAY_LENGTH: 38,
  MAX_DURATION: 39,
  MIN_ANSWER_LIST: 40,
  MIN_1_MAX_NUMBER: 41,
  NUMERIC_WITHOUT_ZERO: 42,
  CORRECT_ANSWER: 43,
  CONFIG_FILE_SIZE: 44,
  MIN_MAX_NUMBER_WITHOUT_LABEL: 45, // #7372
  XML_SIZE_AND_TYPE: 46, // Step SAML
  USER_LOGIN_ID: 47, // Step 7.0 #6
  ITEM_BOX_START: 48, // sprint_20230522_tma
  LOGIN_ID_SU: 49, // Step 11.0.0
};

export const CSV_REGISTRATION_STATUS = {
  PENDING: 0,
  PROCESSING: 1,
  PROCESSED: 2,
};

export const CONFIG_FILE_STATUS = {
  PENDING: 0,
  PROCESSING: 1,
  PROCESSED: 2,
  ERROR: 3,
};

export const ASCENDING_DESCENDING_SORT = {
  DESCENDING: 0,
  ASCENDING: 1,
};

export const ERROR_TYPE = {
  SUCCESS: 0,
  ERROR: 1,
  EMPTY: 2,
  WARNING: 3,
  PRIMARY: 4,
};
export const MESSAGE_TYPE = { success: 'success', error: 'danger', info: 'info', warning: 'warning' };
export const LOCK_TYPE = [{ name: 'アンロック', value: 0 }, { name: 'ロック', value: 1 }];
export const DORMANT_STATE = {
  ACTIVE: 0,
  INACTIVE: 1,
};

export const ADMIN_TYPES = [0, 1, 2];

export const DEFAULT_DATE_FORMAT = 'YYYY/MM/DD';
export const DEFAULT_YEAR_MONTH = 'YYYY/MM';
export const DEFAULT_DATE_FORMAT_SEARCH = 'YYYY-MM-DD';
export const DEFAULT_YEAR_MONTH_SEARCH = 'YYYY-MM'; // #7386

export const DEFAULT_DATE_FORMAT_SERVER = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_DATE_FORMAT_SERVER_NO_SECOND = 'YYYY-MM-DD HH:mm';
export const DEFAULT_DATE_SHORT_FORMAT_SERVER = 'YYYY-MM-DD';

export const DEFAULT_DATE_FORMAT_DETAIL = 'YYYY/MM/DD HH:mm:ss';

export const DEFAULT_DATE_FORMAT_SHORT_DETAIL = 'YYYY/MM/DD HH:mm';

export const DEFAULT_DATE_FORMAT_NO_MINUTE = 'YYYY/MM/DD HH:00';
export const DEFAULT_DATE_FORMAT_SERVER_NO_MINUTE = 'YYYY-MM-DD HH:00';
export const DEFAULT_DATE_TO = '9999/12/31';
export const DEFAULT_DATE_FROM = '1111/01/01';
export const DEFAULT_DATE_TO_TEXT = '提出期限無し';
export const DEFAULT_DATE_FROM_TEXT = '即時返却';
export const SELECT_REPORT_RESPONSE_DATA = {
  ITEM_REPORT_LIST: 0,
  CHECKER_USER_LIST: 1,
};

export const MAX_SMALL_INT = 32767;
export const MAX_INT = 2147483647;

export const ADAPTIVE_MAX_NUM = {
  ADAPTIVE_DRILL_DECISION_QUESTION_NUMBER: 10,
  ADAPTIVE_DRILL_MAX_QUESTION_NUMBER: 100,
};

export const NUM_ATTRIBUTE_QUESTION_SEARCH = 5;
export const NUM_ATTRIBUTE_QUESTION_SEARCH_MAX = 20;
export const REG_EXP = /(https?:\/\/\S+)/g;
export const WAIT_RENDER_TIME = 1000;


export const PREVIEW_QUESTION_WINDOW_NAME = 'previewQuestionWindow';
export const QUESTION_DETAIL_WINDOW_NAME = 'questionDetailWindow';
export const PREVIEW_EACH_QUESTION_ATTRIBUTE_NAME = 'previewEachQuestionAttribute';
export const CONTENT_QUESTION_DETAIL_PREVIEW_REG_EXP = /\/content\/question\/\w+\/preview/g;

export const MIN_SCORING_COL = 0;
export const MAX_SCORING_COL = 5;
export const MIN_IFRAME_QUESTION_COL = 7;
export const MAX_IFRAME_QUESTION_COL = 12;

export const DORMANT_STATE_CHANGE_FLAG = {
  DO_NOT_CHANGE: 0,
  CHANGE_WHILE_RUNNING: 1,
  CHANGE_WHILE_PAUSING: 2,
};

export const DEFAULT_VIDEO_SPEED_LIST = ['0.5', '0.75', '1.0', '1.25', '1.5', '2.0'];
export const HYPHEN = '-';

// AWS configuration
// export const AWS_BUCKET = 'ss-txdev-s3-ntttx-video-source';
export const AWS_REGION = 'ap-northeast-1';
export const S3_CACHE_HOURS_AGO = 4;
// #7287 START
export const REPORT_SCRIPT_S3_PATH = 'FrontGW/NonCh/Script/Service/:institutionId/drillViewPoint.js';
export const ADMIN_SCRIPT_S3_PATH = 'FrontGW/NonCh/Script/Service/:institutionId/adminWeb.js';
// #7287 END
// video type
export const VIDEO_TYPE = ['mp4', 'avi', 'divx', 'xvid', 'f4v', 'flv',
  'mkv', 'mpg', 'mpeg', 'm4v', 'mov', 'vob', 'wmv', 'asf'];
export const DEFAULT_VIDEO_TYPE = 'mp4';
export const PLAY_BUTTON_ICON = '▶';

// TUTORIAL VIDEO CONFIGURATION
export const VIDEO_STEP1 = ROOT_URL.concat('/manual/tutorial/step1.mp4');
export const VIDEO_STEP2 = ROOT_URL.concat('/manual/tutorial/step2.mp4');
export const VIDEO_STEP3 = ROOT_URL.concat('/manual/tutorial/step3.mp4');

// download example path
export const SAMPLE_PATH = '/manual/csvsample/';

export const SLASH_SEPARATOR = '/';
export const DOT_SAPERATOR = '.';

// Default selected video speed value
export const DEFAULT_SELECTED_VIDEO_SPEED_LIST = ['1.0'];

// Step 7.0 START
export const INQUIRY_SUPPORT_URL = `${REDIRECT_DOMAIN}/support/`; // #sprint_20230508_28
// Step 7.0 END

// ########## MOCK SERVER ENVIRONEMT ##########
export const IS_USE_MOCK_SERVER = false;
export const MOCK_SERVER_URL = 'http://localhost:8090/newfront';
export const USE_MOCK_API = [];
// ###########################################
// sprint_20230418_#10 START
export const GTM_CODE = 'GTM-TD73K2F';
// sprint_20230418_#10 END

// sprint_20230418_#17 START
export const CONTACT_URL = 'https://meetings.hubspot.com/ss_support-gm/all';
// sprint_20230418_#17 END

// #sprint_20230508_28 START
export const PAYMENT_URL = `${REDIRECT_DOMAIN}/payment/`;
// #sprint_20230508_28 END

// sprint_20230522_tma START
// ########## HUBAPI ENVIRONEMT ##############
export const HUBAPI_SERVER_URL = 'https://pqyn3k2jf1.execute-api.ap-northeast-1.amazonaws.com/prod';
export const EVENT_NAME = 'pe22714465_ss_cancel_reason';
export const OBJECT_ID = '11172380765';
export const AUTHORIZATION = 'Bearer pat-na1-29f13fb9-6e62-4fc0-bbd2-1347adf66eb4';
// ###########################################
// sprint_20230522_tma END

export const FAQ_URL = 'https://ss.ntte-apps.com/knowledge';

// Step 9.0.0 START
export const ADMIN_DIRECT_CONTRACT_LOGIN_URL = `${REDIRECT_DOMAIN}/cms/login-admin/`;
export const ADMIN_OEM_LOGIN_URL = `${REDIRECT_DOMAIN}/cms/auth-admin/`;
// Step10.0.0 START
export const SUPERUSER_DIRECT_CONTRACT_LOGIN_URL = `${REDIRECT_DOMAIN}/cms/login/`;
export const SUPERUSER_OEM_LOGIN_URL = `${REDIRECT_DOMAIN}/cms/auth/`;
// Step10.0.0 END
export const AUTH_OBJECT_USING_API_LIST = [
  'EachQuestion'
];
// Step 9.0.0 END

//STEP10.0.0 START
export const SERVICE_SORT_TYPE = {
  SERVICE_TYPE: 0,
  SERVICE_CD: 1,
  SERVICE_NAME: 2,
  ENTERPRISE_NAME: 4,
  CREATED_AT: 8,
  UPDATED_AT: 9,
};
// Config new course management page
export const NEW_COURSE_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/courses`;
export const COURSE_LAYOUT_TYPE = {
  NEW: 'new',
  OLD: 'old',
};
export const DRILL_CLIENT_URL = `${COMMON_DOMAIN}/dcv2`;
//STEP10.0.0 END
// STEP10.2.0 START
export const NEW_ADMIN_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/admins`;
export const NEW_SERVICE_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/services`;
// STEP10.2.0 END
// STEP11.0.0 START
export const CERTIFICATE_COMPLETION_URL = `${REDIRECT_DOMAIN}/cms/userfront/certificateCompletion`;
export const KNOWLEDGE_ADMIN_REGISTER_URL = 'https://ss.ntte-apps.com/knowledge/admins/register ';
// STEP11.0.0 END
// STEP12.0.0 START
export const NEW_USER_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/users`;
export const NEW_GROUP_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/groups`;
export const ENTERPRISE_SWITCHING_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/accessible-enterprises`;
export const INTEGRATION_USER_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/integration-users`;
export const CONTENT_GROUP_MANAGEMENT_URL = `${REDIRECT_DOMAIN}/cms/content-groups`;
export const MAIL_TEMPLATE_USERS_URL = `${REDIRECT_DOMAIN}/cms/mail-template/`;
export const NEW_PASSWORD_SETTING_URL = `${REDIRECT_DOMAIN}/cms/password/setting/new-password/`;
// STEP12.0.0 END
// STEP13.0.0 START
export const FUNCTIONAL_EXTENSION_URL = 'https://ss.ntte-apps.com/knowledge/functionalextension';
// STEP13.0.0 END
